import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import store from "./store/index.js";
import App from "./App";
import "./assets/css/color.css";

import api from "./api/index.js";

import "wowjs/css/libs/animate.css";
import Router from "vue-router";
import Swiper from "swiper";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import router from "./router";
// axios.defaults.headers['Content-Type'] = "application/x-www-form-urlencoded"
// import axios from 'axios'
// Vue.prototype.$axios = axios

// import api from './api/index.js'
router.beforeEach((to, from, next) => {
  api
    .seo()
    .then(res => {
      // console.log(res,"main")
      document.title = res.data.data.title;
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", res.data.data.keywords);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", res.data.data.description);
    })
    .catch(err => {
      ElementUI.Message.error("数据获取失败");
    });
  next();
});

import "./assets/css/reset.css";
import qs from "qs";
import { data } from "jquery";
import headImgUrl from "./api/headimgUrl";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.prototype.$headImgUrl = headImgUrl;

Vue.prototype.$qs = qs;

Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
new Vue({
  el: "#app",
  store,
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js